import { MouseEvent, useState } from 'react';
import { Popover } from 'react-tiny-popover';

import { FilterButton, FilterPopover } from './components';
import { IFilterProps } from './types';

export const Filter = ({ button, popover }: IFilterProps) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const handleOnClick = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setIsPopoverOpen(!isPopoverOpen);
  };

  const handleOnClear = () => {
    setIsPopoverOpen(false);
    popover.onClear();
  };

  const handleClose = (event: Event) => {
    event.stopPropagation();
    setIsPopoverOpen(false);
  };

  return (
    <Popover
      align="end"
      reposition={false}
      padding={8}
      isOpen={isPopoverOpen}
      onClickOutside={handleClose}
      positions={['bottom']}
      content={<FilterPopover {...popover} onClear={handleOnClear} />}
    >
      <FilterButton {...button} onClick={handleOnClick} />
    </Popover>
  );
};
